import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';

import ModalWrapper from '../../ModalWrapper';
import FormInput from '../../FormInput';

const PushNotificationValidation = ({
  openModal = false,
  onChange,
  password = '',
  onLoading = '',
  onModalOpen,
  validateResponseReceived = false,
  validationMessage = 'validated',
  onValidate,
  feedback = '',
}) => {
  return (
    <>
      {validateResponseReceived ? (
        <ModalWrapper isOpen={openModal}>
          <h4 className="text-center">{validationMessage}</h4>
        </ModalWrapper>
      ) : (
        <ModalWrapper isOpen={openModal}>
          <div>
            <h4>Authenticate to send push notification</h4>
            <hr />
            <FormInput
              type="password"
              name="password"
              onChange={onChange}
              value={password}
              placeholder="Enter your application password"
              className="form_password"
            />
            {feedback && (
              <div style={{ color: 'red', marginBottom: '15px' }}>
                {feedback}
              </div>
            )}
            <div className="button-div">
              <button type="button" onClick={() => onValidate(password)}>
                {onLoading ? (
                  <div className="button-loader">
                    <Spinner size="sm" /> Confirming
                  </div>
                ) : (
                  <>Confirm</>
                )}
              </button>
              <button type="button" onClick={onModalOpen}>
                Cancel
              </button>
            </div>
          </div>
        </ModalWrapper>
      )}
    </>
  );
};

PushNotificationValidation.propTypes = {
  openModal: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  password: PropTypes.string,
  onLoading: PropTypes.bool,
  onModalOpen: PropTypes.func.isRequired,
  validateResponseReceived: PropTypes.bool,
  validationMessage: PropTypes.string,
  feedback: PropTypes.string,
};

export default PushNotificationValidation;
